import { useQuery } from '@tanstack/react-query';
import { useTableRequest } from '@dfl/mui-admin-layout';
import { ResolutionStatusService } from '../services';
import { RESOLUTION_STATUS_LIST_KEY } from '../constants/resolution-status.queries';

export const useFindResolutionStatuses = () => {
  const { fetch, queryKey } = useTableRequest((params, config) => {
    return ResolutionStatusService.search({ ...params, size: 200 }, config);
  });

  return useQuery({
    queryKey: [RESOLUTION_STATUS_LIST_KEY, queryKey],
    queryFn: fetch,
  });
};
